var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 1H3v1h6zM2 1v1a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2v1.5A1.5 1.5 0 0 0 3.5 12h5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2V1a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1m8 7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1V6a.5.5 0 0 1 1 0v4.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V6a.5.5 0 0 1 1 0zm-5.5 6.5A.5.5 0 0 1 5 14h14a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5m0-7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 9.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5M8 4H7v1h1z",
    clipRule: "evenodd"
  })));
});
const SvgPrintsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrintsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDFIM1YySDlWMVpNMiAxVjJDMC44OTU0MzEgMiAwIDIuODk1NDMgMCA0VjdDMCA4LjEwNDU3IDAuODk1NDMxIDkgMiA5VjEwLjVDMiAxMS4zMjg0IDIuNjcxNTcgMTIgMy41IDEySDguNUM5LjMyODQzIDEyIDEwIDExLjMyODQgMTAgMTAuNVY5QzExLjEwNDYgOSAxMiA4LjEwNDU3IDEyIDdWNEMxMiAyLjg5NTQzIDExLjEwNDYgMiAxMCAyVjFDMTAgMC40NDc3MTUgOS41NTIyOCAwIDkgMEgzQzIuNDQ3NzIgMCAyIDAuNDQ3NzE1IDIgMVpNMTAgOEMxMC41NTIzIDggMTEgNy41NTIyOCAxMSA3VjRDMTEgMy40NDc3MiAxMC41NTIzIDMgMTAgM0g5SDNIMkMxLjQ0NzcyIDMgMSAzLjQ0NzcyIDEgNFY3QzEgNy41NTIyOCAxLjQ0NzcyIDggMiA4VjZDMiA1LjcyMzg2IDIuMjIzODYgNS41IDIuNSA1LjVDMi43NzYxNCA1LjUgMyA1LjcyMzg2IDMgNlY4VjlWMTAuNUMzIDEwLjc3NjEgMy4yMjM4NiAxMSAzLjUgMTFIOC41QzguNzc2MTQgMTEgOSAxMC43NzYxIDkgMTAuNVY5VjhWNkM5IDUuNzIzODYgOS4yMjM4NiA1LjUgOS41IDUuNUM5Ljc3NjE0IDUuNSAxMCA1LjcyMzg2IDEwIDZWOFpNNC41IDE0LjVDNC41IDE0LjIyMzkgNC43MjM4NiAxNCA1IDE0SDE5QzE5LjI3NjEgMTQgMTkuNSAxNC4yMjM5IDE5LjUgMTQuNUMxOS41IDE0Ljc3NjEgMTkuMjc2MSAxNSAxOSAxNUg1QzQuNzIzODYgMTUgNC41IDE0Ljc3NjEgNC41IDE0LjVaTTQuNSA3QzQuMjIzODYgNyA0IDcuMjIzODYgNCA3LjVDNCA3Ljc3NjE0IDQuMjIzODYgOCA0LjUgOEg3LjVDNy43NzYxNCA4IDggNy43NzYxNCA4IDcuNUM4IDcuMjIzODYgNy43NzYxNCA3IDcuNSA3SDQuNVpNNCA5LjVDNCA5LjIyMzg2IDQuMjIzODYgOSA0LjUgOUg2LjVDNi43NzYxNCA5IDcgOS4yMjM4NiA3IDkuNUM3IDkuNzc2MTQgNi43NzYxNCAxMCA2LjUgMTBINC41QzQuMjIzODYgMTAgNCA5Ljc3NjE0IDQgOS41Wk04IDRIN1Y1SDhWNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";